import React from 'react';
import styled from 'styled-components';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Typography, Alert
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    border-radius: 16px;
    padding: 10px;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ff9800;
  margin-bottom: 10px;
`;

const BetaTermsModal = ({ open, onAccept, onLogout }) => {
    return (
        <StyledDialog open={open} maxWidth="sm" fullWidth disableEscapeKeyDown>
            <DialogTitle>
                <Header>
                    <WarningIcon fontSize="large" />
                    <Typography variant="h5" fontWeight="bold">Beta Access Warning</Typography>
                </Header>
            </DialogTitle>
            <DialogContent>
                <Alert severity="warning" sx={{ mb: 3 }}>
                    This is a BETA version of Kritical Watching.
                </Alert>
                <Typography paragraph>
                    Please match the following terms before proceeding:
                </Typography>
                <Typography component="div" variant="body1" sx={{ pl: 2, borderLeft: '3px solid #eee' }}>
                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                        <li><strong>No Data Privacy:</strong> Your movie ratings, lists, and activity may be visible to admins or wiped during updates.</li>
                        <li><strong>Data Loss:</strong> Everything you save (ratings, watchlist, etc.) could be wiped out at any time without notice.</li>
                        <li><strong>No Guarantees:</strong> Features may break or change significantly.</li>
                    </ul>
                </Typography>
                <Typography paragraph sx={{ mt: 3, fontWeight: 'medium' }}>
                    By clicking "Accept & Enter", you acknowledge these risks and agree to participate in the testing phase.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 2, display: 'flex', justifyContent: 'space-between' }}>
                <Button onClick={onLogout} color="inherit">
                    Cancel & Logout
                </Button>
                <Button
                    onClick={onAccept}
                    variant="contained"
                    color="warning"
                    size="large"
                    autoFocus
                >
                    Accept & Enter
                </Button>
            </DialogActions>
        </StyledDialog>
    );
};

export default BetaTermsModal;
